import styled from 'styled-components';

export const BonusInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0;

  @media (max-width: 768px) {
    padding: 0 18px;
  }
`;
